import { render, staticRenderFns } from "./deleteElement.vue?vue&type=template&id=3dc7cb5c&scoped=true&"
import script from "./deleteElement.vue?vue&type=script&lang=js&"
export * from "./deleteElement.vue?vue&type=script&lang=js&"
import style0 from "./deleteElement.vue?vue&type=style&index=0&id=3dc7cb5c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc7cb5c",
  null
  
)

export default component.exports